import './index.css'

import React from 'react'
import ReactDOM from 'react-dom/client'
import {BrowserRouter as Router, useRoutes} from 'react-router-dom'

import ScrollToCorrectPageLocation from './components/ScrollToCorrectPageLocation'
import {router} from './routes/index'

const App = () => {
  return useRoutes(router)
}

const root = ReactDOM.createRoot(document.getElementById('root'))
root.render(
  <Router>
    <ScrollToCorrectPageLocation />
    <App />
  </Router>
)
